const Vue = require('vue')
const createDOMPurify = require('dompurify')

const DOMPurify = createDOMPurify(window)

Vue.component('inline-html-sandbox', {
    props: {
        html: {
            required: true
        },
        maxHeight: {
            type: Number,
            default: 300
        }
    },
    data () {
        return {
            safeHtml: null
        }
    },
    ready () {
        this.update(this.html)
    },
    methods: {
        update (html) {
            setTimeout(() => {
                this.safeHtml = DOMPurify.sanitize(html)
            }, 0)
        }
    },
    watch: {
        html () {
            this.update(this.html)
        }
    },
    template: `
        <div class="inline-html-sandbox" :style="{maxHeight: maxHeight + 'px', overflow: 'auto'}">
            {{{ safeHtml }}}
        </div>
    `
})




// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/inline-html-sandbox.js